import { ref, uploadBytesResumable } from "firebase/storage";
import { firebaseStorage } from "../services/firebaseStorage";
import { toastStore } from "../utils/toastStore";

export const writeFileToGcs = async (args: {
  file: File;
  path: string;
  bucket: string;
  onProgress: (percentage: number) => void;
  onSuccess?: () => void;
}): Promise<void> => {
  const { file, path, bucket, onProgress, onSuccess } = args;
  const storageRef = ref(firebaseStorage, `gs://${bucket}/${path}`);
  const task = uploadBytesResumable(storageRef, file);
  const filename = file.name || "";

  return new Promise((resolve, reject) => {
    task.on(
      "state_changed",
      (snapshot) => {
        const percentage = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        onProgress(percentage);
      },
      (error) => {
        toastStore.error(`Uploading ${filename} failed.`);
        console.error(error);
        reject();
      },
      () => {
        // on complete
        toastStore.success(`${filename} uploaded successfully.`);
        onSuccess && onSuccess();
        resolve();
      }
    );
  });
};
